import {
  EarningsInsightFilterResponse,
  earningsInsights,
  EarningsInsightsFilterRequest,
} from '@api';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';

export const getEarningsInsightsForChart = async (
  payload: EarningsInsightsFilterRequest
) => {
  const { path, schema } = earningsInsights.postEarningsInsightFilter;

  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined)
  ) as EarningsInsightsFilterRequest;

  return await apiFetch<EarningsInsightFilterResponse>(path, {
    method: 'post',
    body: cleanedPayload,
    schema,
  });
};
